__turbopack_context__.v({
  "actions": "MediaCardCover-module-sass-module__PAcWca__actions",
  "aside": "MediaCardCover-module-sass-module__PAcWca__aside",
  "aside--skeleton": "MediaCardCover-module-sass-module__PAcWca__aside--skeleton",
  "aside-background": "MediaCardCover-module-sass-module__PAcWca__aside-background",
  "aside-content": "MediaCardCover-module-sass-module__PAcWca__aside-content",
  "aside-description": "MediaCardCover-module-sass-module__PAcWca__aside-description",
  "aside-dot": "MediaCardCover-module-sass-module__PAcWca__aside-dot",
  "aside-subtitle": "MediaCardCover-module-sass-module__PAcWca__aside-subtitle",
  "aside-title": "MediaCardCover-module-sass-module__PAcWca__aside-title",
  "favorite": "MediaCardCover-module-sass-module__PAcWca__favorite",
  "main": "MediaCardCover-module-sass-module__PAcWca__main",
  "main--skeleton": "MediaCardCover-module-sass-module__PAcWca__main--skeleton",
  "wrap": "MediaCardCover-module-sass-module__PAcWca__wrap",
});
